const routeGuide = [
  {
    path: '/guide/:id',
    name: 'GuideDetail',
    component: () => import('@/pages/Guide/GuideDetail'),
    meta: {
      layout: 'HomeLayout',
    },
  },
];

export default routeGuide;
